export default __webpack_public_path__ + "static/media/newSet3-2-min.bbc24df5.png";